import PropTypes from 'prop-types'

const KeywordStat = ({ data, field, uint }) =>
  data && data[field] ? (
    <>
      {data[field].toLocaleString()}
      {uint}
    </>
  ) : (
    '-'
  )
export default KeywordStat
KeywordStat.propTypes = {
  data: PropTypes.object,
  field: PropTypes.string,
  uint: PropTypes.string,
}
